/**
 * Bundle Rewards ladder — wires any [data-bbr-root] container (the inline strip inside
 * the picker panel, or a standalone section). Tiles unlock live as the kit count climbs.
 * Count = max of: a `bundle:updated` {detail:{count}} event the picker may dispatch, a
 * MutationObserver on the picker's [data-bb-counter], and the cart's `kit_type` count.
 * Purely presentational — real unlocks are the free-shipping Function + gift watcher.
 */
(function () {
  'use strict';

  var roots = [];
  var pickerCount = 0;
  var cartCount = 0;
  var pickerSeen = false; // a picker is on the page -> track the box being built, not the cart
  var kitType = 'Single Kit';

  // On the build page the ladder reflects the BOX being built (picker). The cart count
  // is only a fallback for contexts with no picker (e.g. a standalone strip / cart).
  function currentCount() { return pickerSeen ? (pickerCount || 0) : (cartCount || 0); }

  function updateAll() {
    var c = currentCount();
    roots.forEach(function (r) { r.update(c); });
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var c = 0;
        var bundleKits = window.BBR_BUNDLE_KITS || {};
        (cart.items || []).forEach(function (it) {
          if (it.product_type === kitType) c += it.quantity;
          else if (bundleKits[it.product_id]) c += bundleKits[it.product_id] * it.quantity; // pre-made bundle = N kits
        });
        cartCount = c;
        updateAll();
      })
      .catch(function () {});
  }

  function observeCounter() {
    var el = document.querySelector('[data-bb-counter]');
    if (!el) return;
    pickerSeen = true;
    var parse = function () {
      var m = (el.textContent || '').match(/\d+/);
      pickerCount = m ? (parseInt(m[0], 10) || 0) : 0;
      updateAll();
    };
    parse();
    new MutationObserver(parse).observe(el, { childList: true, characterData: true, subtree: true });
  }

  function makeRoot(rootEl) {
    if (rootEl._bbr) return null;
    rootEl._bbr = true;
    if (rootEl.getAttribute('data-kit-type')) kitType = rootEl.getAttribute('data-kit-type');
    var unit = rootEl.getAttribute('data-unit') || 'kits';
    var statusEl = rootEl.querySelector('[data-bbr-status]');
    var railFill = rootEl.querySelector('[data-bbr-rail-fill]');
    var tiles = Array.prototype.slice.call(rootEl.querySelectorAll('[data-bbr-tile]')).map(function (el) {
      return {
        el: el,
        threshold: parseInt(el.getAttribute('data-threshold'), 10) || 0,
        req: el.querySelector('[data-bbr-req]'),
        name: ((el.querySelector('.bbr-tile__name') || {}).textContent || 'a reward').trim()
      };
    }).sort(function (a, b) { return a.threshold - b.threshold; });
    var last = tiles.length ? tiles[tiles.length - 1].threshold : 0;

    return {
      update: function (count) {
        var nextLocked = null;
        tiles.forEach(function (t) {
          var unlocked = count >= t.threshold;
          var was = t.el.classList.contains('is-unlocked');
          t.el.classList.toggle('is-unlocked', unlocked);
          if (unlocked && !was) { t.el.classList.remove('bbr-pop'); void t.el.offsetWidth; t.el.classList.add('bbr-pop'); }
          if (t.req) t.req.textContent = unlocked ? 'Unlocked!' : 'Add ' + (t.threshold - count) + ' more';
          if (!unlocked && nextLocked === null) nextLocked = t;
        });
        tiles.forEach(function (t) { t.el.classList.toggle('is-next', t === nextLocked); });
        if (railFill) railFill.style.width = (last > 0 ? Math.min(1, count / last) * 100 : 0) + '%';
        if (statusEl) {
          if (nextLocked) {
            var rem = nextLocked.threshold - count;
            statusEl.textContent = 'Add ' + rem + ' more ' + (rem === 1 ? unit.replace(/s$/, '') : unit) + ' to unlock ' + nextLocked.name + '!';
          } else if (tiles.length) {
            statusEl.textContent = '🎉 All rewards unlocked!';
          }
        }
      }
    };
  }

  function initRoots() {
    document.querySelectorAll('[data-bbr-root]').forEach(function (el) {
      var r = makeRoot(el);
      if (r) roots.push(r);
    });
    updateAll();
  }

  function boot() {
    document.addEventListener('bundle:updated', function (e) {
      if (e && e.detail && typeof e.detail.count === 'number') { pickerSeen = true; pickerCount = e.detail.count; updateAll(); }
    });
    observeCounter();
    refreshCart();
    ['theme:cart:change', 'theme:product:added', 'theme:cart:update', 'theme:cart:reload'].forEach(function (ev) {
      document.addEventListener(ev, refreshCart);
    });
    initRoots();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', initRoots);
})();
